import { useState } from 'react'
import { toast } from 'sonner'

type MaxLengthConfig<K extends string> = Record<K, number>

export function useExpandableNames<K extends string = string>(
  maxLengths?: MaxLengthConfig<K>,
) {
  const [expanded, setExpanded] = useState<Record<K, boolean>>(
    {} as Record<K, boolean>,
  )

  const getMaxLength = (key: K) => maxLengths?.[key] ?? 20

  function toggleExpanded(nameList: string[], key: K) {
    const maxLength = getMaxLength(key)
    const hasLongNames = nameList?.some((name) => name.length > maxLength)

    const isExpanding = expanded[key]

    function getMessage(item: string) {
      return `Não há ${item} com mais de ${maxLength} caracteres para ${isExpanding ? 'minimizar' : 'expandir'}.`
    }

    if (!hasLongNames) {
      switch (key.toLowerCase()) {
        case 'email' as K:
          toast.warning(getMessage('e-mails'))
          break
        case 'title' as K:
          toast.warning(getMessage('títulos'))
          break
        case 'professional_document' as K:
          toast.warning(getMessage('registros profissionais'))
          break
        case 'descricao' as K:
          toast.warning(getMessage('descrições'))
          break
        default:
          toast.warning(getMessage('nomes'))
      }
      return
    }

    setExpanded((prev) => ({
      ...prev,
      [key]: !prev[key],
    }))
  }

  return { expanded, toggleExpanded, getMaxLength }
}
